import React from 'react';
import {useConfig} from "../../context/configContext";
import theme from "./styles";

const ContentContainer = ({children}) => {
  const config = useConfig();
  const classes = theme(config);

  return (
    <div className={classes.contentContainer}>{children}</div>
  )
}

export default ContentContainer;